if (!customElements.get('faq-page')) {
  class FaqPage extends HTMLElement {
    connectedCallback() {
      this.pills = this.querySelectorAll('[data-faq-pill]');
      this.categories = this.querySelectorAll('[data-faq-category]');

      if (!this.pills.length || !this.categories.length) return;

      this.pills.forEach((pill) => {
        pill.addEventListener('click', (e) => {
          e.preventDefault();
          const slug = pill.dataset.faqPill;
          const target = this.querySelector(`[data-faq-category="${slug}"]`);
          if (target) {
            const offset = 112;
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        });
      });

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const slug = entry.target.dataset.faqCategory;
              this._setActivePill(slug);
            }
          });
        },
        { rootMargin: '-120px 0px -60% 0px', threshold: 0 }
      );

      this.categories.forEach((cat) => this._observer.observe(cat));
      this._setActivePill(this.categories[0].dataset.faqCategory);
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }

    _setActivePill(slug) {
      this.pills.forEach((pill) => {
        const isActive = pill.dataset.faqPill === slug;
        pill.style.color = isActive ? 'rgb(190, 67, 0)' : 'rgba(190, 67, 0, 0.6)';
        pill.style.borderColor = isActive ? 'rgb(190, 67, 0)' : 'rgba(190, 67, 0, 0.4)';
      });
    }
  }

  customElements.define('faq-page', FaqPage);
}
